<h1 mat-dialog-title data-cy="serial-number-title">Add Serial Number</h1>
<mat-dialog-content>
  <div class="flex flex-col justify-start items-stretch space-y-4">
    <p data-cy="serial-number-message">
      The product <em>{{ data.name }}</em> requires that you add a serial number
      when it is sold.
    </p>
    <mat-form-field>
      <mat-label>Serial Number</mat-label>
      <input
        matInput
        [formControl]="serialNumberInput"
        data-cy="serial-number"
        placeholder="Serial Number"
        autofocus
      />
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="space-x-4">
  <button mat-flat-button [mat-dialog-close]="null">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="serialNumberInput.invalid"
    [mat-dialog-close]="serialNumberInput.value"
    data-cy="save-button"
  >
    Save
  </button>
</mat-dialog-actions>
